<script setup lang="ts">
import { UiIcon, UiText } from "@shopexperts/shared";
</script>

<template>
  <span
    class="inline-flex min-h-11 items-center gap-1.5 rounded-md px-4 py-2 font-semibold text-se-dark"
  >
    <UiText as="span" variant="button" text="Open" />
    <UiIcon
      name="arrow-right"
      class="w-3.5 h-3.5 -rotate-45 transition-transform duration-200 group-hover/ui-button:rotate-0"
    />
  </span>
</template>
